import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateEntity } from '../utils/generate-base-entity'
import { WebsiteButtonEntityInterface } from './website-button.schema'

export const createWebsiteButton = (
  parentId: string,
  text: string,
  subText: string,
  masterBlockId?: MasterBlockIdType,
): WebsiteButtonEntityInterface => ({
  ...generateEntity(EntityTypeEnum.WebsiteButton, parentId, masterBlockId),
  action: ButtonActionTypeEnum.OpenUrl,
  linkUrl: '',
  iconClassNameBefore: '',
  iconClassNameAfter: '',
  alignSelf: 'center',
  text,
  subText,
  boxShadow: 'none',
  mobileAlignSelf: 'center',
  mobileBoxShadow: 'none',
  margin: {
    marginTop: 25,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
  },
  mobileMargin: {
    marginTop: 5,
    marginRight: 0,
    marginBottom: 5,
    marginLeft: 0,
  },
})
